import { render } from "./viewExpense.vue?vue&type=template&id=015a0938&scoped=true"
import script from "./viewExpense.vue?vue&type=script&lang=js"
export * from "./viewExpense.vue?vue&type=script&lang=js"

import "./viewExpense.vue?vue&type=style&index=0&id=015a0938&scoped=true&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015a0938"]])

export default __exports__